import { css, cx } from '@linaria/atomic';
import { ListboxChildren } from '../../../listbox/listbox.provider';
import { Text } from '../../../text';
import { DropdownInput } from '../../atoms/dropdown-input.component';
import { InputProps } from '../../atoms/types';
import { useDropdownContext } from '../../providers/dropdown-provider';
import { DropdownInputStyles } from '../dropdown/input-styles';
import { getSelectedChild } from '../dropdown/utils';
import { MultiselectSelection } from './multiselect-selection';
import { MultiselectSelectionStyles } from './multiselect-selection.styles';

const multiselectInputDropdownInputStyle1 = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

type Props = InputProps<'multiselect'> & {
  options: ListboxChildren;
};

export const MultiselectInput = ({ options, value, ...rest }: Props) => {
  const { triggerProps } = useDropdownContext();
  const visibleChild = getSelectedChild({ children: options, value });
  const remainder = value.length - 1;
  const remainderStyles = MultiselectSelectionStyles.remainderStyles;

  return (
    <DropdownInput
      as='div'
      displayValue={
        value.length > 0 ? (
          <>
            <MultiselectSelection
              selectionCount={value.length}
              onRemove={() => {
                rest.onChange({ name: rest.name, value: visibleChild?.props.value });
                setTimeout(() => {
                  triggerProps.ref.current?.focus();
                }, 0);
              }}
            >
              {visibleChild?.props.children}
            </MultiselectSelection>
            {remainder > 0 && (
              <Text color='light' className={remainderStyles}>
                +{remainder} more
              </Text>
            )}
          </>
        ) : null
      }
      value=''
      {...rest}
      {...triggerProps}
      className={cx(multiselectInputDropdownInputStyle1, !value.length ? DropdownInputStyles.placeholderStyle : '')}
    />
  );
};
